<section
  tabindex="-1"
  aria-live="polite"
  aria-relevant="additions text"
  aria-atomic="false"
  [attr.aria-label]="ariaLabel()"
>
  @for (group of groups(); track group.position) {
    <ol
      #list
      tabindex="-1"
      data-wma-toaster
      [attr.data-x-position]="group.x"
      [attr.data-y-position]="group.y"
      [style.--front-toast-height]="group.frontHeight + 'px'"
      [style.--gap]="gap() + 'px'"
      [style.--viewport-offset]="offset() + 'px'"
      [style.--mobile-viewport-offset]="mobileOffset() + 'px'"
      (mouseenter)="hovered.set(group.position)"
      (mousemove)="hovered.set(group.position)"
      (mouseleave)="interacting() || hovered.set(null)"
      (pointerdown)="onPointerDown($event)"
      (focusin)="onFocusIn($event, group.position)"
      (focusout)="onFocusOut($event)"
    >
      @for (item of group.items; track item.toast.id) {
        <li
          wma-toast
          [toast]="item.toast"
          [index]="item.index"
          [count]="group.items.length"
          [offset]="item.offset"
          [visible]="item.index < visibleToasts()"
          [expanded]="isExpanded(group.position)"
          [paused]="isPaused(group.position)"
          [defaults]="defaults()"
          [attr.data-y-position]="group.y"
          (heightChange)="onHeightChange(item.toast.id, $event)"
        ></li>
      }
    </ol>
  }
</section>
